import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../Theme';

const ContentWrapper = styled('div')`
  max-width: 700px;
  margin: auto;
  width: 100%;
  display: block;
  font-weight: normal;

  img {
    max-width: 100%;
  }

  h2 {
    font-size: 1.5rem;
    line-height: 1.3;
    margin-bottom: 20px;
  }
  h3 {
    font-size: 1.2rem;
    line-height: 1.3;
    margin-bottom: 20px;
  }
  h4 {
    font-size: 1rem;
    line-height: 1.3;
    margin-bottom: 20px;
  }
  p {
    margin-bottom: 1rem;
    font-size: 13px;
    font-weight: normal;
    line-height: 1.5;
  }
  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    font-weight: 600;
  }
`;

const ShortcodeContent = ({ children }) => (
  <ContentWrapper>{children}</ContentWrapper>
);

export default ShortcodeContent;
